export const CALENDAR_CELLS_GAP = 2;
